<template>
  <div class="wi-100x pr postsSvg">
   <svg height="400" viewBox="0 0 1173 853" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_21_229)">
        <!-- 风筝线 -->
        <path id="postssvg-kite-line" d="M391.6 306.7C390.1 306.7 388.9 306.5 388 306C386.2 305.1 386 303.7 385.9 303.5C385.8 303 386.2 302.5 386.8 302.4C387.3 302.3 387.8 302.7 387.9 303.3C387.9 303.3 388 303.9 389 304.3C391.4 305.3 400 305.9 429 288.5C469.5 264.2 508.6 145.9 509 144.8L509.2 144.2H509.9C511.1 144.1 631.5 137.2 711.6 119.1C796.6 99.9 1030.3 33.4 1032.7 32.7C1033.2 32.5 1033.8 32.9 1033.9 33.4C1034.1 33.9 1033.7 34.5 1033.2 34.6C1030.8 35.3 797.1 101.8 712 121C634.9 138.4 520.6 145.5 510.7 146.1C507.2 156.6 470 266.3 430 290.3C411.9 301.1 398.8 306.7 391.6 306.7Z" fill="#1F1E1C"/>
        <!-- 人物 -->
        <g>
          <path d="M860.1 463.6H58.5V466.5H860.1V463.6Z" fill="#1F1E1C"/>
          <!-- 腿状态1 -->
          <path id="postssvg-leg" d="M487.4 813.8C463.2 789 461 767.9 461 767.7V767.5L442.3 528.2L358.9 435.5C358.5 433.6 352 424.7 336.6 425.9C333.9 426.2 331.1 426.1 328.4 425.6C318.8 423.8 318 421.6 320.7 419.1C323 417.1 304 395 304 395L293 376.3V369H288.6L246.8 370L183.7 371C183.7 371 183.4 382.3 184.1 397.5C184.4 404.1 184.8 411.5 185.6 419.1C186.6 430.7 188.6 451.1 191.6 462.3L382.3 566.6L416.1 763.1H416L417.7 806L490.4 817L487.4 813.8ZM420.7 803.4L419.2 766.3L458.2 769.2C459 774 463 791.7 482.2 812.7L420.7 803.4Z" fill="#F04626"/>
          <!-- 腿状态2 -->
          <!-- <path d="M447.4 813.8C423.2 789 421 767.9 421 767.7V767.5L442.3 528.2L358.9 435.5C358.5 433.6 352 424.7 336.6 425.9C333.9 426.2 331.1 426.1 328.4 425.6C318.8 423.8 318 421.6 320.7 419.1C323 417.1 304 395 304 395L293 376.3V369H288.6L246.8 370L183.7 371C183.7 371 183.4 382.3 184.1 397.5C184.4 404.1 184.8 411.5 185.6 419.1C186.6 430.7 188.6 451.1 191.6 462.3L380.3 563.6L376.1 763.1H376L377.7 806L450.4 817L447.4 813.8ZM380.7 803.4L379.2 766.3L418.2 769.2C419 774 423 791.7 442.2 812.7L380.7 803.4Z" fill="#F04626"/> -->
          <path d="M751.9 406.3C734.7 411.8 721.2 412.4 712.9 411.8C703.9 411.2 698.9 409.3 698.9 409.3L698.1 409L496.2 312.6L374.5 362.1L352 371.2L335.9 377.7L294.9 394.4L255.9 435.2L241.2 473.8C250.1 481.2 259.6 487.8 269.7 493.5C284 501.3 341.2 487.5 395.5 471.5C420.9 451.7 447 429.6 467.3 412C489.1 393 504.2 379.3 504.2 379.3L674.7 447.5L713.9 465.1L756.2 404.9L751.9 406.3ZM712.8 461.3L679 446.1L699 412.5C703.7 414 721.2 418.2 748.6 410.4L712.8 461.3Z" fill="#F04626"/>
          <path d="M303.1 401C293 424.2 261.5 445.8 242.1 452.1C219.4 459.5 193.4 463.7 186 457.9C178.6 452.1 168.2 408.5 167.4 385.1C167.3 384.9 159.4 242.4 159.6 238.5C157.6 217.7 162.4 198 181.4 190.6L196.5 184.6C196.5 184.6 211.5 156.8 213.3 160.7C215.7 165.8 240.8 167.3 251 159.7C253.9 157.5 264.9 181.9 264.9 181.9L294.1 194.9C301.8 198.3 307.4 205.2 309.2 213.5C319.7 261.6 299.4 271.6 299 287.5C297.5 341.4 296.9 352 297.9 360.4C298.9 368.8 307.6 390.6 303.1 401Z" fill="#1F1E1C"/>
          <!-- 手 -->
          <path id="postssvg-person-hand" d="M521 153.3C517.3 160.2 508.7 162.8 501.8 159.1C501.1 158.7 500.5 158.3 499.9 157.9L438.4 192.7L424.6 178.1L498 137.3C503.2 131.5 512.1 130.9 518 136.1C522.8 140.4 524.1 147.5 521 153.3Z" fill="#F04626"/>
          <!-- 胳膊 -->
          <path id="postssvg-person-arm" d="M244 235.5L243.1 246.7L365.6 245.1L487.4 176.6L469.6 149.2L362.5 194.2L286.4 195.7C264.1 196.2 245.9 213.4 244 235.5Z" fill="#1F1E1C"/>
          <path d="M404.4 297.2C402.1 300.4 395.4 299.6 389.5 295.4C383.6 291.2 380.7 285.1 383 281.9C385.3 278.7 393 278.5 398.9 282.7C404.8 286.9 406.7 294 404.4 297.2Z" fill="#1F1E1C"/>
          <path d="M380.3 324.2L356.4 308.2C356.4 308.2 373 293.6 383.4 284.6C391.6 277.5 406.1 291.7 401.3 297.6C398.1 301.5 380.3 324.2 380.3 324.2Z" fill="#F04626"/>
          <path d="M381.5 326.6C378.4 330.4 370.2 329 363.2 323.3C356.2 317.7 353 310 356 306.2C359.1 302.4 368.3 302.8 375.3 308.5C382.3 314.2 384.6 322.7 381.5 326.6Z" fill="#1F1E1C"/>
          <path d="M268.566 125.312C272.088 103.615 257.353 83.1707 235.656 79.6494C213.958 76.128 193.515 90.8626 189.993 112.56C186.472 134.257 201.207 154.701 222.904 158.223C244.601 161.744 265.045 147.009 268.566 125.312Z" fill="#F04626"/>
          <path d="M374.5 332.9C369.1 338.7 360.2 338.9 354.4 333.7C353.8 333.1 353.3 332.6 352.9 332L284.5 350L274.9 332.3L356.3 311.5C362.8 307.2 371.6 308.9 375.9 315.5C379.6 320.9 379 328.1 374.5 332.9Z" fill="#F04626"/>
          <path d="M163.5 230.9L232.5 360.8L345.5 341.6L343.2 313.1L248.3 323.6C248.3 323.6 209.8 216.1 207.6 210.1C205.4 204.1 189.8 197.6 178 201.6C166.2 205.6 158.9 222.9 163.5 230.9Z" fill="#1F1E1C"/>
          <!-- 头发 状态2 -->
          <path id="postssvg-hair" d="M261.3 59.5C246.4 31 201.2 44.1 201.2 44C198 35.9 194.2 31.1 186.5 29C158.2 21.4 126.8 39.7 132.5 86.2C136.9 122.2 126 142.5 121.1 155.5C116.4 168 79.1 182.7 65.8 210.3C44.2 254.9 48 277.1 14.1 289.1C-19.8 301.1 8.70001 376.3 85.3 369C145 363.3 128.7 284.8 144.5 242.6C155.3 213.9 151.6 187.6 151.6 171.1C151.6 154.5 160.2 147.8 160.6 134.6C168.3 149.8 168.3 154.5 192.2 152.5C193.4 152.4 196 173 197.2 173.1C199.5 155.5 210.2 154 208.3 140.9C204 112.1 215.6 102.5 219.5 101.2C223.4 99.9 231.7 101.2 231.7 101.2C234.3 97.3 236.5 92.7 236.2 88C238 92.1 239 96.6 239.2 101.2C265.8 110.3 268.9 100.1 268.9 100.1C268 83.8 264.6 65.7 261.3 59.5Z" fill="#1F1E1C"/>
          <!-- 头发 状态3 -->
          <!-- <path d="M261.3 59.5C242.4 33.6 201.2 44.1 201.2 44C198 35.9 189.5 29.6 181.5 29C152.3 26.8 129.5 43.4 132.5 90.2C134.5 120.7 134.3 151.1 121.1 155.5C90.1 165.9 86.7 195.2 63.1 219.1C31.8 250.8 42.2 266.5 14.1 289.1C-13.9 311.6 9.10001 379.6 85.3 369C141.9 361.1 137.6 287.1 144.5 242.6C149.1 212.8 138.9 192.9 152.6 171.1C160.4 158.7 161.2 147.8 161.6 134.6C169.3 149.8 176 151.3 194.2 151.5C195.4 151.4 191 172 192.2 172.1C202.5 160.9 210.4 144.1 209.3 130.9C208.1 117 213.8 101.4 219.5 99.2C223.3 97.7 231.7 100.2 231.7 100.2C234.3 96.3 236.5 92.7 236.2 88C238 92.1 239 94.6 239.2 99.2C254.7 109.7 268.9 104.1 268.9 104.1C268 87.8 269.1 70.2 261.3 59.5Z" fill="#1F1E1C"/> -->
        </g>
        <!-- 风筝 -->
        <g id="postssvg-kite">
          <!-- 风筝尾巴1 状态1 -->
          <!-- <path id="postssvg-kite-tail1" d="M1070.9 78.6C1070.9 78.6 1075.1 104 1088.8 112C1096.2 116.3 1104.4 124.6 1105.6 135.5C1106.9 147.2 1114.2 143.5 1109.7 132.1C1105.1 120.2 1104.2 117.2 1088.1 107.1C1074.4 98.4 1077.5 79.9 1070.9 78.6Z" fill="#1F1E1C"/> -->
          <!-- 风筝尾巴1 状态2 -->
          <path id="postssvg-kite-tail1" d="M1070.9 78.6C1070.9 78.6 1069.8 99.7 1083.5 107.6C1090.9 111.9 1104.8 121.1 1105.6 135.4C1106.2 147.1 1113.6 140 1109.1 128.5C1104.5 116.6 1099.6 113 1083.5 102.9C1069.9 94.4 1077.5 79.9 1070.9 78.6Z" fill="#1F1E1C"/>
          <!-- 风筝尾巴2 状态1-->
          <!-- <path id="postssvg-kite-tail2" d="M1072.4 81.4C1072.4 81.4 1084.8 102.8 1096.1 101.1C1119.6 97.5 1135.6 109.1 1138 114.6C1139.3 117.5 1137.6 119.4 1135.6 117.7C1123.6 107.7 1114.9 102.3 1095.7 104.3C1085 105.5 1068.5 81.9 1072.4 81.4Z" fill="#1F1E1C"/> -->
          <!-- 风筝尾巴2 状态2-->
          <path id="postssvg-kite-tail2" d="M1072.4 81.4C1072.4 81.4 1084.6 97 1096.1 97.1C1116.9 97.3 1125.1 105.2 1136 114.6C1138.4 116.7 1135.5 119.4 1133.6 117.7C1120.7 106.1 1112.1 100.3 1094.7 100.3C1083.9 100.4 1068.6 81.9 1072.4 81.4Z" fill="#1F1E1C"/>
          <path d="M1075.7 86.5L1016.3 61.3C1016.3 61.3 1012.5 53.2 1024.3 12.5L1073.5 15.4C1073.6 15.4 1080.7 61.7 1075.7 86.5Z" fill="#F04626"/>
          <path d="M1025 12.5H1024.4C1024.2 13.3 1023.9 14.1 1023.7 14.9C1027.7 25.7 1040.8 56.1 1071.3 84.6L1075.7 86.5C1075.7 86.3 1075.8 86.2 1075.8 86C1041.4 55.2 1028.1 21.5 1025 12.5Z" fill="#1F1E1C"/>
          <path d="M1073.6 15.4L1069.3 15.1C1063.6 16.3 1055.3 18.6 1046.9 22.8C1030.4 31 1019.8 43.4 1015.8 58.9C1016 60.7 1016.3 61.3 1016.3 61.3L1017.2 61.7C1020.5 45.5 1030.7 33.1 1047.7 24.6C1058.2 19.4 1068.6 17.2 1073.7 16.3C1073.7 15.7 1073.6 15.4 1073.6 15.4Z" fill="#1F1E1C"/>
        </g>
        <!-- 花儿 -->
        <g id="postssvg-flower">
          <!-- 叶子2 -->
          <path id="postssvg-leaf2" d="M901.2 698.6C886.3 641 825 614.9 825 614.9C847.6 697 901.2 698.6 901.2 698.6Z" fill="#EF4624"/>
          <!-- 叶子3 -->
          <path id="postssvg-leaf3" d="M956.6 661C949.3 676.5 951.9 689.8 944.6 705.9C936.2 724.5 907.8 730.9 907.8 730.9C915.5 667.4 972.1 637.1 972.1 637.1C972.1 637.1 961.9 649.9 956.6 661Z" fill="#EF4624"/>
          <!-- 叶子1 -->
          <path id="postssvg-leaf1" d="M859.8 768.5C864.4 774.3 870 779.1 890.7 783.2C909.5 786.8 915.4 799 915.4 799C913.9 766 839 731 839 731C847.8 737.9 852.4 759.2 859.8 768.5Z" fill="#EF4624"/>
          <path d="M932.8 784.7C931.2 784.7 929.8 786 929.8 787.7C929.8 788.1 929.9 788.5 930 788.9C926.4 793.9 917.7 807.2 916.7 819.4C916.6 820.2 917.3 820.9 918.1 821H918.2C919 821 919.6 820.4 919.7 819.6C920.6 808.2 929 795.5 932.4 790.6C932.5 790.6 932.6 790.6 932.7 790.6C934.3 790.6 935.7 789.3 935.7 787.6C935.8 786.1 934.4 784.7 932.8 784.7Z" fill="#1F1E1C"/>
          <path d="M915.7 765.8C913.5 749.2 888.2 734 880.4 729.7C880.3 728.1 879 726.8 877.4 726.8C875.8 726.8 874.4 728.1 874.4 729.8C874.4 731.4 875.7 732.8 877.4 732.8C878 732.8 878.5 732.6 878.9 732.4C886.4 736.6 910.7 751.2 912.7 766.2C912.8 767 913.4 767.5 914.2 767.5C914.3 767.5 914.3 767.5 914.4 767.5C915.2 767.4 915.8 766.6 915.7 765.8Z" fill="#1F1E1C"/>
          <path d="M908.7 728.8C900.1 702.1 901.6 670.3 902.2 661.3C903.2 660.8 903.9 659.8 903.9 658.6C903.9 657 902.6 655.6 900.9 655.6C899.3 655.6 897.9 656.9 897.9 658.6C897.9 659.6 898.4 660.5 899.2 661C898.5 670.2 897 702.5 905.8 729.7C915.6 760.2 914.3 803 912.9 816.9C912.8 817.7 913.4 818.5 914.2 818.5H914.3C915.1 818.5 915.7 817.9 915.8 817.1C916 816.7 920.7 766.1 908.7 728.8Z" fill="#1F1E1C"/>
        </g>
        <!-- 盆儿 -->
        <path d="M935.9 852.4H892.9L885.1 813.9H943.7L935.9 852.4Z" fill="#1F1E1C"/>
        <!-- 猫猫 -->
        <g>
          <!-- 胳膊 -->
          <g id="postssvg-cat-arm">
            <path d="M800.688 793.229C800.688 793.229 828.515 818.044 833.332 822.302C838.149 826.559 842.229 832.613 839.259 836.11C837.55 838.065 835.047 842.092 826.354 837.025C817.661 831.957 780.03 811.884 775.751 809.544C771.527 807.289 757.129 801.174 755.312 796.387C753.496 791.601 794.773 787.659 800.688 793.229Z" fill="#EF4624"/>
            <path d="M824.799 814.739C826.699 816.364 831.983 821.153 833.386 822.385C838.203 826.643 842.284 832.697 839.313 836.194C837.605 838.148 835.101 842.176 826.408 837.108C824.09 835.757 819.425 833.193 814.18 830.291C808.797 827.359 815.303 806.253 824.799 814.739Z" fill="#1F1E1D"/>
          </g>
          <path d="M788.4 818.8C789.6 809.3 803.6 779.1 810.9 773.2C818.2 767.3 820.8 762.4 816.5 756.6C812.3 750.7 796.8 759.4 796.8 759.4C796.8 759.4 778.5 750.3 768.9 756.6C759.3 762.9 753.1 770.1 733.4 775.8C713.7 781.4 681.8 780.9 675.6 781.3C669.4 781.7 679.4 850.5 679.4 850.5H786.6C786.8 850.4 787 829.5 788.4 818.8Z" fill="#1F1E1D"/>
          <path d="M787.6 776.5C794.1 776.5 803.6 771.6 807.9 763.8C812.1 756 810.4 756 807.9 752.9C805.4 749.8 797.8 741.7 793.5 741.3C789.3 740.8 786.5 742.5 786.5 739.8C786.5 737.1 786.5 734.6 786.5 734.6C786.5 734.6 782.6 737.7 778.9 743C775.2 748.3 767.4 754.8 766.8 758.8C766.2 762.7 773 776.5 787.6 776.5Z" fill="#EF4624"/>
          <!-- 尾巴状态1 -->
          <!-- <path id="postssvg-cat-tail" d="M635.3 812.3C635.3 812.3 624.6 822.2 590 823.3C555.4 824.4 528.6 821.3 523.6 821.3C518.6 821.3 511.2 831.8 521.9 836.2C532.6 840.6 572.6 842.4 598.7 838.2C624.9 834 633.6 830.9 633.6 830.9L635.3 812.3Z" fill="#EF4624"/> -->
          <!-- 尾巴状态2 -->
          <path id="postssvg-cat-tail" d="M635.3 812.3C635.3 812.3 624.6 816 590 810.3C557.5 805 530.6 783 523.6 783.3C518.5 783.5 512.7 791.2 521.9 798.2C531.9 805.8 560.8 818.6 586.7 824.2C612 829.6 633.6 830.9 633.6 830.9L635.3 812.3Z" fill="#EF4624"/>
          <!-- 尾巴状态3 -->
          <!-- <path d="M635.3 812.3C635.3 812.3 624.6 816 590 810.3C557.5 805 554.7 775.9 553.6 773.3C551.9 769.3 539 768.8 540.9 780.2C542.4 789.2 553 818.7 586.7 824.2C612.3 828.3 633.6 830.9 633.6 830.9L635.3 812.3Z" fill="#EF4624"/> -->
          <path d="M720.3 850.4C723.1 844.2 724.7 837.4 724.7 830.2C724.7 803.2 702.8 781.2 675.7 781.2C648.7 781.2 626.7 803.1 626.7 830.2C626.7 837.4 628.3 844.3 631.1 850.4H720.3Z" fill="#EF4624"/>
          <path d="M801.2 760.1C802.967 760.1 804.4 758.981 804.4 757.6C804.4 756.219 802.967 755.1 801.2 755.1C799.433 755.1 798 756.219 798 757.6C798 758.981 799.433 760.1 801.2 760.1Z" fill="#1F1E1D"/>
          <path d="M786.3 734.6C786.3 734.6 783.5 741.4 783.2 746.3C782.9 751.2 783.2 758.9 786.3 758.4C789.4 757.9 790.2 750.7 789.5 746.3C788.8 741.9 786.3 734.6 786.3 734.6Z" fill="#1F1E1D"/>
          <path d="M811.7 756.7C813.302 756.7 814.6 756.207 814.6 755.6C814.6 754.992 813.302 754.5 811.7 754.5C810.098 754.5 808.8 754.992 808.8 755.6C808.8 756.207 810.098 756.7 811.7 756.7Z" fill="#EF4624"/>
          <path d="M771.8 803.3C766.5 794 756.3 777.8 742.8 781.2C729.3 784.6 725.6 801.3 735.5 810.9C745.4 820.5 782.2 850.4 782.2 850.4H813.7C813.7 850.4 809.5 838.4 801.6 836.1C793.7 833.9 787.2 833.3 786.7 831.9C786.2 830.6 771.8 803.3 771.8 803.3Z" fill="#EF4624"/>
          <path d="M720.6 839.3C714.4 839.3 709.5 844.3 709.5 850.4H731.8C731.7 844.3 726.7 839.3 720.6 839.3Z" fill="#EF4624"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_21_229">
          <rect width="1172.1" height="852.4" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  </div>
</template>
<script>
export default {
  name: 'postsSvg',
  data () {
    return {
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化
    init () {
      this.animation()
    },
    // 动画
    animation () {
      var anime = this.$anime
      // 1000毫秒后开始动画
      setTimeout(() => {
        var leg = document.getElementById('postssvg-leg') // 腿
        var leaf1 = document.getElementById('postssvg-leaf1') // 叶子1
        var leaf2 = document.getElementById('postssvg-leaf2') // 叶子2
        var leaf3 = document.getElementById('postssvg-leaf3') // 叶子3
        var hair = document.getElementById('postssvg-hair') // 头发
        var catArm = document.getElementById('postssvg-cat-arm') // 猫爪子
        var catTail = document.getElementById('postssvg-cat-tail') // 猫尾巴
        var flower = document.getElementById('postssvg-flower') // 花儿
        var hand = document.getElementById('postssvg-person-hand') // 人物手
        var arm = document.getElementById('postssvg-person-arm') // 人物胳膊
        var kiteLine = document.getElementById('postssvg-kite-line') // 风筝线
        var kite = document.getElementById('postssvg-kite') // 风筝
        var kiteTail1 = document.getElementById('postssvg-kite-tail1') // 风筝尾巴1
        var kiteTail2 = document.getElementById('postssvg-kite-tail2') // 风筝尾巴2
        // 风筝尾巴变换1
        anime({
          loop: true,
          targets: kiteTail1,
          easing: 'easeInOutQuad',
          direction: 'alternate',
          duration: 500,
          d: 'M1070.9 78.6C1070.9 78.6 1075.1 104 1088.8 112C1096.2 116.3 1104.4 124.6 1105.6 135.5C1106.9 147.2 1114.2 143.5 1109.7 132.1C1105.1 120.2 1104.2 117.2 1088.1 107.1C1074.4 98.4 1077.5 79.9 1070.9 78.6Z'
        })
        // 风筝尾巴变换2
        anime({
          loop: true,
          targets: kiteTail2,
          easing: 'easeInOutQuad',
          direction: 'alternate',
          duration: 500,
          d: 'M1072.4 81.4C1072.4 81.4 1084.8 102.8 1096.1 101.1C1119.6 97.5 1135.6 109.1 1138 114.6C1139.3 117.5 1137.6 119.4 1135.6 117.7C1123.6 107.7 1114.9 102.3 1095.7 104.3C1085 105.5 1068.5 81.9 1072.4 81.4Z'
        })
        // 胳膊和手
        var handArm = anime({
          targets: [hand, arm],
          easing: 'easeInOutQuad',
          direction: 'alternate',
          translateX: -10,
          translateY: 10,
          duration: 500,
          // endDelay: 200,
          loop: 4
        })
        // 风筝线
        var kiteLineAnime = anime({
          targets: kiteLine,
          easing: 'easeInOutQuad',
          direction: 'alternate',
          translateX: -10,
          translateY: 5,
          duration: 500,
          // endDelay: 200,
          loop: 4
        })
        // 风筝
        var kiteAnime = anime({
          targets: kite,
          easing: 'easeInOutQuad',
          direction: 'alternate',
          translateX: -8,
          // translateY: 8,
          rotate: -5,
          duration: 500,
          // endDelay: 200,
          loop: 4
        })
        setInterval(() => {
          handArm.restart()
          kiteLineAnime.restart()
          kiteAnime.restart()
        }, 4000)
        // anime({
        //   targets: catArm,
        //   rotate: 50,
        //   translateY: 40,
        //   translateX: 3,
        //   loop: 1,
        //   easing: 'cubicBezier(.6, .5,.4, .4)',
        //   // translateX: 4,
        //   // direction: 'alternate',
        //   duration: 1000,
        //   autoplay: true
        // })
        var catArmTimeline = anime.timeline({
          targets: catArm,
          easing: 'cubicBezier(.6, .5,.4, .4)',
          autoplay: true,
          // direction: 'alternate',
          duration: 600,
          loop: true
        })
        catArmTimeline.add({
          targets: catArm,
          rotate: [0, -60],
          translateY: [0, 0],
          translateX: [0, 35],
          delay: 200
        }).add({
          duration: 500,
          rotate: [-60, 0],
          translateY: 0,
          translateX: [35, 0]
        }).add({}, '+=1800')
        var tailTimeline = anime.timeline({
          targets: catTail,
          easing: 'easeInOutQuad',
          autoplay: true,
          duration: 700,
          direction: 'alternate',
          loop: true
        })
        tailTimeline.add({
          // 3
          d: 'M635.3 812.3C635.3 812.3 624.6 816 590 810.3C557.5 805 554.7 775.9 553.6 773.3C551.9 769.3 539 768.8 540.9 780.2C542.4 789.2 553 818.7 586.7 824.2C612.3 828.3 633.6 830.9 633.6 830.9L635.3 812.3Z'
        }).add({
          // 2
          d: 'M635.3 812.3C635.3 812.3 624.6 816 590 810.3C557.5 805 530.6 783 523.6 783.3C518.5 783.5 512.7 791.2 521.9 798.2C531.9 805.8 560.8 818.6 586.7 824.2C612 829.6 633.6 830.9 633.6 830.9L635.3 812.3Z'
        }).add({
          // 3
          d: 'M635.3 812.3C635.3 812.3 624.6 816 590 810.3C557.5 805 554.7 775.9 553.6 773.3C551.9 769.3 539 768.8 540.9 780.2C542.4 789.2 553 818.7 586.7 824.2C612.3 828.3 633.6 830.9 633.6 830.9L635.3 812.3Z'
        }).add({
          // 2
          d: 'M635.3 812.3C635.3 812.3 624.6 816 590 810.3C557.5 805 530.6 783 523.6 783.3C518.5 783.5 512.7 791.2 521.9 798.2C531.9 805.8 560.8 818.6 586.7 824.2C612 829.6 633.6 830.9 633.6 830.9L635.3 812.3Z'
        })
        setTimeout(() => {
        // 花儿动
          anime({
            targets: flower,
            loop: true,
            easing: 'easeInOutQuad',
            direction: 'alternate',
            duration: 1200,
            autoplay: true,
            rotate: 8,
            translateX: 16,
            delay: 600,
            endDelay: 100
          })
          // 叶子1动
          var leaf1Anime = anime({
            targets: leaf1,
            loop: 8,
            easing: 'cubicBezier(.6, .5,.8, .7)',
            direction: 'alternate',
            duration: 350,
            autoplay: true,
            rotate: 3,
            translateX: 1,
            translateY: -2
            // delay: 600,
            // endDelay: 100
            // delay: 100
          })
          setInterval(() => {
            leaf1Anime.restart()
          }, 3900)
        }, 800)
        // 叶子2动
        anime({
          targets: leaf2,
          loop: true,
          easing: 'cubicBezier(.6, .5,.8, .7)',
          direction: 'alternate',
          duration: 1200,
          autoplay: true,
          rotate: 5,
          translateX: 3,
          translateY: -2
          // delay: 100
        })
        // 叶子3动
        anime({
          targets: leaf3,
          loop: true,
          easing: 'cubicBezier(.6, .5,.8, .7)',
          direction: 'alternate',
          duration: 1200,
          autoplay: true,
          rotate: 5,
          translateX: 4,
          translateY: 3
          // delay: 100
        })
        // 腿切换
        var legtimeline = anime.timeline({
          targets: leg,
          direction: 'alternate', // 反方向播放
          autoplay: true,
          loop: true,
          easing: 'easeInOutQuad',
          endDelay: 50
        })
        legtimeline.add({
          duration: 800,
          loop: true,
          d: 'M447.4 813.8C423.2 789 421 767.9 421 767.7V767.5L442.3 528.2L358.9 435.5C358.5 433.6 352 424.7 336.6 425.9C333.9 426.2 331.1 426.1 328.4 425.6C318.8 423.8 318 421.6 320.7 419.1C323 417.1 304 395 304 395L293 376.3V369H288.6L246.8 370L183.7 371C183.7 371 183.4 382.3 184.1 397.5C184.4 404.1 184.8 411.5 185.6 419.1C186.6 430.7 188.6 451.1 191.6 462.3L380.3 563.6L376.1 763.1H376L377.7 806L450.4 817L447.4 813.8ZM380.7 803.4L379.2 766.3L418.2 769.2C419 774 423 791.7 442.2 812.7L380.7 803.4Z'
        })
        anime({
          targets: hair,
          d: 'M261.3 59.4C235.3 31.5 203.2 44 203.2 43.9C200 35.8 197.2 32 189.5 29.9C161.2 22.3 126.8 39.6 132.5 86.1C136.9 122.1 129.3 144.9 121.1 155.4C112.9 165.9 75.5 178.1 65.8 210.2C51.4 257.6 51 277 17.1 289C-16.8 301 31.7 380.8 85.3 368.9C151.8 354.1 146.5 278.9 144.5 242.5C142.5 206.2 151.3 173.6 154.7 167.7C158.6 161 161.2 147.7 161.6 134.5C169.3 149.7 176.6 156.6 194.2 154.4C195.4 154.3 200 172.9 201.2 173C205.3 165.8 210.9 149.1 208.3 140.8C198.9 111.1 215.6 102.4 219.5 101.1C223.4 99.8 232.7 101.1 232.7 101.1C235.3 97.2 236.5 92.6 236.2 87.9C238 92 239 96.5 239.2 101.1C265.8 110.2 273.9 99 273.9 99C273 82.7 266.6 65.2 261.3 59.4Z',
          duration: 1000,
          delay: 400,
          endDelay: 50,
          loop: true,
          direction: 'alternate', // 反方向播放
          easing: 'easeInOutQuad'
        })
      }, 1000)
    }
  }
}
</script>
<style>
.postsSvg {
  width: 100%;
}
.postsSvg svg {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/compos/postsSvg.vue